<div>
  <!--<div class="content-header">
    <logo [src]="settings.loginLogo" [width]="247" [height]="133"></logo>
  </div>-->
  <div class="content-body" style="width: 100%">
    <router-outlet></router-outlet>
  </div>
</div>
